import {createContext} from 'react';

const PusherContext = createContext(null);

export default PusherContext;
